module.exports = __webpack_public_path__ + "static/img/h7.0ad9f93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hor/h7.jpg
// module id = 64I8
// module chunks = 1